<template />

<script setup>
import { useRouter } from 'vue-router';

import { useAuthStore } from '@/store/index.js';

const authStore = useAuthStore();
const router = useRouter();

const currentDistrict = authStore.user.districts.find(district => district.current);

// If the user has a current district, redirect them to the list of plans for that district
if (currentDistrict) {
  router.push({ name: 'app_plan_list', params: { district: currentDistrict.id } });
} else {
  router.push({ name: 'app_district_select' });
}
</script>
